const IncomeData = [
    { "label": "₹2 Lakhs", "value": "200000" },
    { "label": "₹2.5 Lakhs", "value": "250000" },
    { "label": "₹3 Lakhs", "value": "300000" },
    { "label": "₹3.5 Lakhs", "value": "350000" },
    { "label": "₹4 Lakhs", "value": "400000" },
    { "label": "₹4.5 Lakhs", "value": "450000" },
    { "label": "₹5 Lakhs", "value": "500000" },
    { "label": "₹6 Lakhs", "value": "600000" },
    { "label": "₹7 Lakhs", "value": "700000" },
    { "label": "₹8 Lakhs", "value": "800000" },
    { "label": "₹9 Lakhs", "value": "900000" },
    { "label": "₹10 Lakhs", "value": "1000000" },
    { "label": "₹11 Lakhs", "value": "₹11 Lakhs" },
    { "label": "₹12 Lakhs", "value": "₹12 Lakhs" },
    { "label": "₹13 Lakhs", "value": "₹13 Lakhs" },
    { "label": "₹14 Lakhs", "value": "₹14 Lakhs" },
    { "label": "₹15 Lakhs", "value": "₹15 Lakhs" },
    { "label": "₹16 Lakhs", "value": "₹16 Lakhs" },
    { "label": "₹17 Lakhs", "value": "₹17 Lakhs" },
    { "label": "₹18 Lakhs", "value": "₹18 Lakhs" },
    { "label": "₹19 Lakhs", "value": "₹19 Lakhs" },
    { "label": "₹20 Lakhs", "value": "₹20 Lakhs" },
  ]
  

  export default IncomeData